exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#canvas[data-v-615bee61]{cursor:crosshair}.file[data-v-615bee61]{float:left;padding:0 15px;border:1px solid #31aaff;color:#31aaff;border-radius:5px;text-align:center;width:100px;height:30px;line-height:30px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-615bee61","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/road/draw.vue
// module id = X57M
// module chunks = 171 239